<template>
  <div class="app">
    <v-card>
      <v-container fluid grid-list-lg>
        <div v-bind="text" class="font-weight-thin title">
          Ques: {{ text.question }}
        </div>
        <v-layout row>
          <v-flex xs12>
            <VueApexCharts
              type="bar"
              height="450"
              :options="chartOptions"
              :series="series"
            ></VueApexCharts>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
  import VueApexCharts from "vue-apexcharts";

  export default {
    components: {
      VueApexCharts,
    },
    props: ["dataset"],
    data() {
      return {
        text: {
          question: null,
        },

        chartOptions: {
          xaxis: {
            categories: [
              "Category 1",
              "Category 2",
              "Category 3",
              "Category 4",
            ],
          },
        },
        series: [
          {
            name: "",
            data: [44, 55, 41, 67],
          },
        ],
      };
    },
    watch: {
      dataset: function () {
        this.initialize();
      },
    },
    created() {
      this.initialize();
    },
    methods: {
      initialize() {
        this.chartOptions.xaxis.categories = this.dataset.graphData.labels;
        this.series[0].data = this.dataset.graphData.series;
        this.text.question = this.dataset.queSet.question;
      },
    },
  };
</script>

<style>
  /* You can add custom styling for the chart container here */
</style>
